import React from 'react'
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text
} from '@chakra-ui/react'
import { MdKeyboardArrowDown } from '@icons/index'
import { BrandFilterType } from './index'

export const AZFilter = ({
  text,
  items,
  setFilter
}: {
  text: string
  items: string[]
  setFilter: (filter: any) => any
}) => {
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<MdKeyboardArrowDown />}
        bg={'white !important'}
        justifyContent={'end'}
        p={0}
        gap={2}
        _hover={{
          bg: 'white'
        }}
        _focus={{
          bg: 'white'
        }}
      >
        <Text color={'black'} textStyle="filterText">
          {text}
        </Text>
      </MenuButton>
      <MenuList>
        {items.map((item) => {
          return (
            <MenuItem
              key={item}
              onClick={(pre) => setFilter({ ...pre, az: item })}
            >
              {item}
            </MenuItem>
          )
        })}
      </MenuList>
    </Menu>
  )
}

export const AllFilter = ({
  text,
  items
}: {
  text: string
  items: string[]
}) => {
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<MdKeyboardArrowDown />}
        bg={'white !important'}
        justifyContent={'end'}
        p={0}
        gap={2}
        _hover={{
          bg: 'white'
        }}
        _focus={{
          bg: 'white'
        }}
      >
        <Text color={'black'} textStyle="filterText">
          {text}
        </Text>
      </MenuButton>
      <MenuList>
        {items.map((item) => {
          return <MenuItem key={item}>{item}</MenuItem>
        })}
      </MenuList>
    </Menu>
  )
}

interface PropsType {
  setFilter: (filter: any) => any
  filter: BrandFilterType
}

const BrandFilter = ({ setFilter, filter }: PropsType) => {
  const { az } = filter

  return (
    <Flex my={12} justifyContent={'space-between'} wrap={'wrap'}>
      <Flex gap={10} wrap={'wrap'} alignItems="center">
        <AllFilter text={'ALL'} items={['All']} />
        <AZFilter text={az} items={['A-Z', 'Z-A']} setFilter={setFilter} />
      </Flex>
    </Flex>
  )
}

export default BrandFilter
